import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/news";

const principles = [
  {
    icon: "ri-shield-check-line",
    title: "不传播未核实的私密信息",
    text: "只讨论已经公开、且可交叉验证的内容。涉及私人行程与家庭信息的部分，我们一律略过。",
  },
  {
    icon: "ri-scales-3-line",
    title: "不把传闻写成事实",
    text: "存在争议的事件会明确标注信息状态，用「疑似」「据称」区分推测与已确认的事实。",
  },
  {
    icon: "ri-emotion-happy-line",
    title: "不做人身攻击",
    text: "我们讨论行为与行业现象，不参与对个人的辱骂与标签化，评论区同样执行这一标准。",
  },
];

export default function BrandSection() {
  return (
    <section id="about" className="mx-auto max-w-content scroll-mt-32 px-4 pt-16 md:px-6 md:pt-20">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <div className="h-full w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20warm%20editorial%20illustration%20of%20a%20newsroom%20desk%20with%20notebooks%2C%20a%20vintage%20camera%20and%20a%20cup%20of%20tea%20by%20a%20window%2C%20soft%20afternoon%20light%2C%20crimson%20and%20amber%20accents%2C%20calm%20thoughtful%20mood%2C%20film%20grain&width=1000&height=900&seq=mrcg-brand-01&orientation=squarish"
                alt="美日吃瓜编辑部工作台意象配图"
                title="关于美日吃瓜 - 我们的内容原则"
                className="h-full min-h-[280px] w-full object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="p-6 md:p-10">
              <SectionHeading
                eyebrow="About us"
                title="我们为什么做「美日吃瓜」"
                description="娱乐新闻不该只有情绪和站队。我们希望提供一个更慢、更理性的入口，让每一场热搜都有据可查。"
              />

              <div className="mt-7 space-y-5">
                {principles.map((item) => (
                  <div key={item.title} className="flex gap-3.5">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className={`${item.icon} text-lg`} aria-hidden="true" />
                    </span>
                    <div>
                      <h3 className="font-heading text-sm font-bold text-foreground-900">
                        {item.title}
                      </h3>
                      <p className="mt-1 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/about"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  了解我们的故事
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </Link>
                <a
                  href="mailto:hello@meirichigua.com"
                  rel="nofollow"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  <i className="ri-mail-line" aria-hidden="true" />
                  hello@meirichigua.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <h3 className="font-heading text-lg font-bold text-foreground-950">读者怎么说</h3>
        <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.quote}
              </blockquote>
              <figcaption className="mt-4 border-t border-background-200 pt-3">
                <span className="block text-sm font-bold text-foreground-900">{item.name}</span>
                <span className="mt-0.5 block text-xs text-foreground-500">{item.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}